import { render, staticRenderFns } from "./BaseFormItem2.vue?vue&type=template&id=118b2be2&scoped=true"
import script from "./BaseFormItem2.vue?vue&type=script&lang=js"
export * from "./BaseFormItem2.vue?vue&type=script&lang=js"
import style0 from "./BaseFormItem2.vue?vue&type=style&index=0&id=118b2be2&prod&lang=scss&scoped=true"
import style1 from "./BaseFormItem2.vue?vue&type=style&index=1&id=118b2be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118b2be2",
  null
  
)

export default component.exports